/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.projectname = {
    init: function () {
        $('.no-ss[href]').each(function () {
            if ($(this).attr('href') != '') {
                var link = $(this).attr('href').split('#')[1];
                $(this).attr('href', '#'+link);
            }
        });
        $('[data-href]').addClass('jslink').on('click', function () {
            var target = $(this).data('href');
            window.location.href=target;
        });
        this.menuInit();
        this.feedbackWidget();
    },
    menuInit: function () {
        // main menu toggle
        $('.overlay-menu a, .overlay-menu input, .overlay-menu button').on('focus', function () {
            $('#hamburger-menu').attr('aria-expanded', true);
            $('.overlay-menu').addClass('active');
        }).on('blur', function () {
            $('#hamburger-menu').attr('aria-expanded', true);
            $('.overlay-menu').removeClass('active');
        });
        $('.menu-opener').on('click', function () {
            $('#hamburger-menu').attr('aria-expanded', true);
            $('.overlay-menu').addClass('active');
        });
        $('.menu-closer').on('keypress click', function () {
            $('#hamburger-menu').attr('aria-expanded', false);
            $('.overlay-menu').removeClass('active');
        });
        $( document ).on('keydown', function ( e ) {
            if ( e.keyCode === 27 ) { // ESC
                $('#hamburger-menu').attr('aria-expanded', false);
                $('.overlay-menu').removeClass('active');
            }
        });
        $('#subscribe-group').on('show.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                // var chevron = $(this).data("chevron");
                $('.subscribe-chevron').removeClass("chevron-down").addClass("chevron-up");
            }
        }).on('hide.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                // var chevron = $(this).data("chevron");
                $('.subscribe-chevron').removeClass("chevron-up").addClass("chevron-down");
            }
        });
        $('#mobile-search-bar-opener, #mobile-search-bar-opener').on('click', function () {
            setTimeout(function () {
                $('#SearchForm_SearchFormMobile_Search').focus();
            }, 500);
        });
    },
    feedbackWidget: function () {
        $('[id*=Form_PageFeedbackForm_IsUseful_]').on('change', function () {
            if (!$('#Form_PageFeedbackForm_Comments').is(':visible')) {
                var value = $('[id*=Form_PageFeedbackForm_IsUseful_]:checked').val();
                $.ajax({
                    method: 'GET',
                    data: {'rate': value},
                    url: so.feedbacklink
                });
            }
        });

        // // hide Submit Feedback button
        $('#Form_PageFeedbackForm_action_submitPageFeedbackForm').hide();

        $('.feedback-expander').on('keypress, click', function () {

            $('#Form_PageFeedbackForm_action_submitPageFeedbackForm').toggle();  // show/hide
            // chevron toggler
            $('.feedback-expander .menu-chevron').toggleClass('chevron-up');
        });

        //additional form fixup for styling overrides
        $('#subscribe-group nav').removeClass('Actions');
    }
};

$(document).ready(function () {
    so.projectname.init();
});
